import { useLang, WHATSAPP_URL } from "../i18n";
import { WhatsAppIcon } from "./Logo";

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
    <div className="group pointer-events-none fixed bottom-5 right-5 z-50 flex items-center gap-3">
      <span className="hidden translate-x-2 rounded-full border border-slate-700/70 bg-[#0B1220]/95 px-4 py-2 text-sm font-medium text-slate-200 opacity-0 shadow-xl backdrop-blur transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block">
        {t.waFloat}
      </span>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label={t.waFloat}
        className="pointer-events-auto relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform group-hover:scale-110"
      >
        <span className="animate-pulse-ring absolute inset-0 rounded-full border-2 border-[#25D366]" />
        <WhatsAppIcon className="h-7 w-7" />
      </a>
    </div>
  );
};
